import { createFileRoute } from '@tanstack/react-router';
import { AdminDeliveryCostCbmPage } from '@/features/admin/admin-delivery-cost-cbm-page';

export const Route = createFileRoute('/admin/delivery-cost/cbm/')({
  component: AdminDeliveryCostCbmRoute,
});

function AdminDeliveryCostCbmRoute() {
  return <AdminDeliveryCostCbmPage />;
}
